import firebase from "firebase";
import { MenuItemAddOn, MenuItemOption } from "../../models";
import { Menu, Section, Subsection } from "../../models/menu";
import { MenuItemMedia, Minus, MenuItem } from "../../models/menuItem";
import { handleRefOrString } from "../../helpers/genericHelper";

export const serializeMenuSnap = (
  menuSnap: firebase.firestore.DocumentSnapshot
): Menu => {
  const data = menuSnap.data() ?? {};
  return serializeMenu(data);
};

export const serializeMenu = (
  data: {[key:string]: any}
): Menu => {
  const serializedMenu = {
    availability: data.availability ?? [],
    description: data.description ?? '',
    docId: data.docId ?? data.id,
    layout: (data.layout ?? []).map((section: any) => ({
      title: section.title,
      description: section.description,
      active: section.active,
      meta: section.meta ?? {},
      sub_sections: (section.sub_sections ?? []).map((sub: any) => ({
        title: sub.title,
        description: sub.description,
        meta: sub.meta ?? {},
        menu_items: (sub.menu_items ?? []).map(
          (ref: firebase.firestore.DocumentReference) => ref.path
        ),
      })).filter((sub: Subsection) => sub.menu_items.length > 0),
    })).filter((section: Section) => section.sub_sections.length > 0),
    meta: data.meta ?? {},
    name: data.name,
    ref: data.ref ?? '',
    status: data.status,
    take_away_delivery_availability: data.take_away_delivery_availability ?? [],
    take_away_delivery_interval: data.take_away_delivery_interval ?? 30,
    used_for_take_away_or_delivery: data.used_for_take_away_or_delivery ?? false,
  };
  return serializedMenu;
};

export const serializeAddOns = (data: {[key: string]: any}): MenuItemAddOn => ({
  max_size: data.max_size ?? 1,
  min_size: data.min_size ?? 0,
  pos: data.pos ?? 0,
  title: data.title ?? '',
  global: data.global,
  meta: data.meta ?? {},
  options: (data.options ?? []).map(serializeOption),
});

export const serializeOption = (data: {[key: string]: any}): MenuItemOption => ({
  id: handleRefOrString(data.id),
  max_size: data.max_size ?? 0,
  meta: data.meta ?? {},
  min_size: data.min_size ?? 0,
  name: data.name ?? '',
  price: data.price ?? 0,
  tax_rate: data.tax_rate ?? 0,
  ref: handleRefOrString(data.ref),
  title: data.title,
});

export const serializeMedia = (data: {[key: string]: any}): MenuItemMedia => ({
  url: data.url ?? '',
});

export const serializeMinus = (data: {[key: string]: any}): Minus => ({
  id: handleRefOrString(data.id),
  meta: data.media ?? {},
  name: data.name ?? '',
  price: data.price ?? 0,
  title: data.title ?? '',
});

export const serializeMenuItemSnap = (menuItem: firebase.firestore.DocumentSnapshot): MenuItem => {
  const data = menuItem.data() ?? {};
  return serializeMenuItem(menuItem.id, data);
};

export const serializeMenuItem = (
  id: string,
  data: {[key:string]: any}
): MenuItem => {
  return {
    add_ons: (data.add_ons ?? []).map(serializeAddOns),
    allergens: data.allergens ?? [],
    average_score: data.average_score ?? 0,
    category: data.category ?? '',
    delivery_point: data.delivery_point ?? '',
    description: data.description ?? '',
    diets: data.diets ?? [],
    id: id,
    ingredients: data.ingredients ?? [],
    ingredients_description: data.ingredients_description,
    media: (data.media ?? []).map(serializeMedia),
    minus: (data.minus ?? []).map(serializeMinus),
    name: data.name ?? '',
    meta: data.meta ?? {},
    price: data.price ?? 0,
    price_txt: data.price_txt ?? '',
    sale_comment: data.sale_comment ?? '',
    status: data.status ?? '',
  }
};